import React, { useState } from "react";
import axios from "axios";
import { Typography, Stack } from "@mui/material";
import { ActionButton } from "./ActionButton";
import { KeyboardArrowLeft } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

const FeedbackForm = ({ type, toolName }) => {
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const payload = {
            type,
            message,
            tool: toolName,
            email,
            metadata: {
                userAgent: navigator.userAgent,
                pageURL: window.location.href,
            },
        };

        try {
            const API_BASE_URL = "http://localhost:3000";
            const response = await axios.post(`${API_BASE_URL}/api/provide-feedback`, payload);
            if (response.status === 201) {
                setSuccess(true);
                setMessage("");
                setEmail("");
            }
        } catch (err) {
            const errorMessage =
                err.response?.data?.error || "Failed to submit feedback.";
            setError(errorMessage);
        }
    };

    return (
        <div>
            <Typography
                id="analyzer-title"
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                    marginTop: "64px",
                    fontWeight: "bold",
                    color: "#3A7BD5",
                    textShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    fontSize: "30px",
                }}
            >
                {type === "bug" ? "Report a Bug" : "Feedback Form"}
            </Typography>

            {!success && !error && (
                <form id="provide-feedback-form" onSubmit={handleSubmit}>
                    <label>
                        Tool:
                        <input
                            type="text"
                            value={toolName}
                            disabled
                            style={{ backgroundColor: "#f0f0f0", color: "#888", height: 25 }}
                        />
                    </label>
                    <label>
                        Email:
                        <input
                            required
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="your-email@example.com"
                            style={{ height: 25 }}
                        />
                    </label>
                    <label>
                        Description:
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Describe the issue or your feedback"
                            required
                            style={{ resize: "none", height: 200 }}
                        />
                    </label>
                    <button type="submit">Submit</button>
                </form>
            )}
            {(success || error) && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {success && (
                        <Typography variant="body1" style={{ color: "green", fontWeight: "bold" }}>
                            Thank you! Your {type} has been submitted.
                        </Typography>
                    )}
                    {error && (
                        <Typography variant="body1" style={{ color: "red", fontWeight: "bold" }}>
                            Error: {error}
                        </Typography>
                    )}
                </div>
            )}
             <Stack
                        spacing={isMobile ? 1 : 2}
                        direction={isMobile ? "column" : "row"}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ marginTop: "20px", marginBottom: "50px" }}
                    >
                        <ActionButton
                            component={Link}
                            to="/"
                            sx={{
                                width: isMobile ? "100%" : "auto",
                                backgroundColor: "#3A7BD5",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#2E6FB6",
                                },
                            }}
                        >
                            <KeyboardArrowLeft /> Back to Home
                        </ActionButton>
                    </Stack>
        </div>
    );
};

export default FeedbackForm;
